export interface TopbarProps {
  onMenuClick: () => void;
}

/**
 * Mobile-only chrome. Hidden on desktop via CSS (`.topbar` defaults to
 * display:none and is shown only at `@media (max-width: 820px)`). On mobile
 * the sidebar is a slide-in drawer; this hamburger is the only way to open
 * it. Brand text doubles as a small wayfinding cue.
 */
export function Topbar({ onMenuClick }: TopbarProps) {
  return (
    <header className="topbar">
      <button
        type="button"
        className="hamburger"
        onClick={onMenuClick}
        aria-label="Open menu"
      >
        <span />
        <span />
        <span />
      </button>
      <div className="crumbs">
        <b>InkyPay</b>
      </div>
    </header>
  );
}
